import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { GoalCollectedAnimation } from '../../animations/GoalCollectedAnimation';
import { GoalId } from '../../defs/goal';

export type GoalEffectOptions = {
  id: GoalId;
  position: PositionType;
  scale: number;
  rotation: number;
};

export class GoalEffect implements IEffect {
  constructor(
    private scene: GameScene,
    private options: GoalEffectOptions,
  ) {}

  public static assets(): string[] {
    return [];
  }

  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    await this.animate();
  }

  private async animate() {
    // create  animation
    const animation = new GoalCollectedAnimation({
      id: this.options.id,
      scale: this.options.scale,
      rotation: this.options.rotation,
    });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this.scene,
      this.options.position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this.scene, entity);
  }
}
